import { toValue } from 'vue';
import {
  filterLocales,
  getAllowedLocales,
  getFallbackLocale,
  parseExcludedLocales,
  type LocaleCode,
} from '~/utils/excludedLocales';


export function useAppLocales() {
  const runtimeConfig = useRuntimeConfig();
  const i18n = useI18n();

  const excludedLocales = computed(() => parseExcludedLocales(runtimeConfig.public.excludedLocales));
  const allowedLocaleCodes = computed(() => getAllowedLocales(excludedLocales.value));
  const fallbackLocale = computed(() => getFallbackLocale(
    excludedLocales.value,
    runtimeConfig.public.defaultLocale,
  ));
  const visibleLocales = computed(() => filterLocales(toValue(i18n.locales), excludedLocales.value));
  const visibleAvailableLocales = computed(() => toValue(i18n.availableLocales).filter(
    (locale): locale is LocaleCode => allowedLocaleCodes.value.includes(locale as LocaleCode),
  ));

  return {
    excludedLocales,
    allowedLocaleCodes,
    fallbackLocale,
    visibleLocales,
    visibleAvailableLocales,
  };
}
